import { render, staticRenderFns } from "./StudentWebinarRoom.vue?vue&type=template&id=79f1dde6&scoped=true&"
import script from "./StudentWebinarRoom.vue?vue&type=script&lang=js&"
export * from "./StudentWebinarRoom.vue?vue&type=script&lang=js&"
import style0 from "./StudentWebinarRoom.vue?vue&type=style&index=0&id=79f1dde6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f1dde6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
